import React, { useState, useEffect } from 'react';

import {
    Box,
    Typography,
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Menu,
    MenuItem,
    Skeleton,
    TableContainer,
    Select,
    Button,
    FormControl,
    InputLabel,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import EditProjectRates from '../../../components/Projects/EditProjectRates';
import RemoveMemberName from '../../../components/Projects/RemoveMemberName';
import EditProject from '../../../components/Projects/EditProject';


const projects = [
    {
        dpath: 'https://randomuser.me/api/portraits/women/68.jpg',
        dname: 'Vansh Saini',
        desk: 'Social Media Strategist',
    },
    {
        dpath: 'https://randomuser.me/api/portraits/men/32.jpg',
        dname: 'Devon Lane',
        desk: 'Social Media Strategist',
    },
    {
        dpath: 'https://randomuser.me/api/portraits/women/44.jpg',
        dname: 'Leslie Alexander',
        desk: 'Social Media Strategist',
    },
    {
        dpath: 'https://randomuser.me/api/portraits/women/45.jpg',
        dname: 'Vansh Saini',
        desk: 'Social Media Strategist',
    },
];

const roles = [
    { label: 'Manager', description: 'Can manage, track, and view reports' },
    { label: 'User', description: 'Can track and view their time' },
    { label: 'Viewer', description: 'Can view reports' },
    { label: 'Manager - via team', description: 'Via task team' },
];


const CustomCheckbox = ({ checked, onChange }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    border: '1px solid #D0D5DD',
                    backgroundColor: '#E5E8EB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);



const ProjectsDetailsTable = () => {
    const [checkedStates, setCheckedStates] = useState({
        email: true,
        push: false,
        sms: false,
        figma: false,
        illust: true,
        window: false,
        file: true,
        google: true,
    });

    const handleChange = (key) => {
        setCheckedStates((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };


    const [role, setRole] = useState('');

    const handleChangeUser = (event, index) => {
        const updatedRoles = [...rolesState];
        updatedRoles[index] = event.target.value;
        setRolesState(updatedRoles);
    };



    const [loading, setLoading] = useState(true);
    const [selectedValues, setSelectedValues] = useState([]);


    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    const handleCheckboxChange = (name) => {
        setSelectedValues((prev) =>
            prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedValues(projects.map((p) => p.name));
        } else {
            setSelectedValues([]);
        }
    };




    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [openEditProjectRates, setOpenEditProjectRates] = useState(false);
    const [openRemoveMemberName, setOpenRemoveMemberName] = useState(false);
    const [openEditProject, setOpenEditProject] = useState(false);

    const [rolesState, setRolesState] = useState(
        projects.map(() => "")   // initialize for each row
    );





    return (
        <div>
            <TableContainer sx={{ boxShadow: 'none' }}>
                <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', backgroundColor: '#f5f6fa', borderSpacing: '0 6px' }}>
                    <TableHead>
                        <TableRow sx={{
                            backgroundColor: '#DFDFDF',
                            '& th:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                            '& th:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                        }}>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }} padding="checkbox">
                                <CustomCheckbox
                                    checked={projects.length > 0 && selectedValues.length === projects.length}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>#</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Member</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Role</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Pay rate/Bill rate</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }} align='center'>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>
                        {loading
                            ? [...Array(6)].map((_, i) => (
                                <TableRow key={i}>
                                    {[...Array(6)].map((_, j) => (
                                        <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                    ))}
                                </TableRow>
                            ))
                            : projects.map((project, index) => (
                                <TableRow key={index} sx={{
                                    borderRadius: '8px',
                                    '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap' }} padding="checkbox">
                                        <CustomCheckbox
                                            checked={selectedValues.includes(project.name)}
                                            onChange={() => handleCheckboxChange(project.name)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }}>{index + 1}</TableCell>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Avatar variant="pill-rounded" sx={{ width: '46px', height: '46px', backgroundColor: 'unset', backgroundSize: 'cover', objectFit: 'cover' }}>
                                                <img src={project.dpath} className='img-fluid' alt='Drive Icon' sx={{ width: '46px', height: '46px', backgroundSize: 'cover', objectFit: 'cover' }} />
                                            </Avatar>
                                            <Box>
                                                <Typography sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>
                                                    {project.dname}
                                                </Typography>
                                                <Typography fontSize={12} color="text.secondary" sx={{ fontFamily: 'Manrope' }}>
                                                    {project.desk}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }}>


                                        <Box sx={{ width: 240 }}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <Select
                                                    value={rolesState[index]}
                                                    onChange={(event) => handleChangeUser(event, index)}
                                                    displayEmpty
                                                    renderValue={(selected) =>
                                                        selected ? (
                                                            selected
                                                        ) : (
                                                            <Typography color="text.secondary" sx={{ fontSize: '14px', color: '#64748B', fontWeight: '400', fontFamily: 'Manrope' }}>
                                                                Select user
                                                            </Typography>
                                                        )
                                                    }
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        borderRadius: 1,
                                                        fontFamily: 'Manrope',
                                                        fontSize: '14px',
                                                        color: '#64748B'
                                                    }}
                                                >
                                                    {roles.map((option) => (
                                                        <MenuItem key={option.label} value={option.label}>
                                                            <Box>
                                                                <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{option.label}</Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '14px', color: '#595959', fontWeight: '400', fontFamily: 'Manrope' }} color="text.secondary">
                                                                    {option.description}
                                                                </Typography>
                                                            </Box>
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            sx={{
                                                '&:hover .edit-btn': {
                                                    visibility: 'visible',
                                                },
                                            }}
                                        >
                                            No pay rate/No bill rate
                                            <Button
                                                onClick={() => setOpenEditProject(true)}
                                                className="edit-btn"
                                                sx={{
                                                    // minWidth: '24px',
                                                    // width: '24px',
                                                    // height: '24px',
                                                    // color: '#0076FE',
                                                    // border: '1px solid #0076FE',
                                                    // borderRadius: '100px',
                                                    // textAlign: 'center',
                                                    // lineHeight: '1.1',
                                                    backgroundColor: 'none',
                                                    visibility: 'hidden', // Hidden by default
                                                }}
                                            >
                                                <img src='./assets/images/app-activity/edit-circle-icon.svg' alt='edit circle icon' className='img-fluid' />
                                                {/* <ModeEditIcon sx={{ fontSize: '14px' }} /> */}
                                            </Button>
                                        </Box>
                                    </TableCell>

                                    {/* <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }}>
                                        <Box display="flex" alignItems="center" justifyContent="space-between">No pay rate/No bill rate
                                            <Button onClick={() => setOpenEditProject(true)} sx={{
                                                minWidth: '24px', width: '24px', height: '24px', color: '#0076FE', border: '1px solid #0076FE', borderRadius: '100px', textAlign: 'center',
                                                lineHeight: '1.1'
                                            }}><ModeEditIcon sx={{ fontSize: '14px' }} /></Button>
                                        </Box>
                                    </TableCell> */}
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }} align='center'>
                                        <Button
                                            variant="outlined"
                                            endIcon={<KeyboardArrowDownIcon />}
                                            onClick={handleClick}
                                            sx={{
                                                borderRadius: '100px',
                                                textTransform: 'none',
                                                borderColor: '#0076FE',
                                                color: '#0076FE',
                                                fontWeight: 600,
                                                fontSize: '16px',
                                                fontFamily: 'Manrope',
                                                height: '36px',
                                                width: '140px',
                                                justifyContent: 'space-around',
                                            }}
                                        >
                                            Action
                                        </Button>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            PaperProps={{
                                                elevation: 3,
                                                sx: {
                                                    borderRadius: 2,
                                                    minWidth: 180,
                                                    mt: 0,
                                                    boxShadow: '0 0 4px #00000026',
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => { setOpenEditProjectRates(true); handleClose(); }} sx={{ fontSize: '14px', color: '#1A1F36', fontFamily: 'Manrope' }} >Edit pay/bill rate</MenuItem>
                                            <MenuItem onClick={() => { setOpenRemoveMemberName(true); handleClose(); }} sx={{ fontSize: '14px', color: '#1A1F36', fontFamily: 'Manrope' }} >Remove member</MenuItem>
                                        </Menu>
                                    </TableCell>

                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <EditProjectRates open={openEditProjectRates} onClose={() => setOpenEditProjectRates(false)} />
            <RemoveMemberName open={openRemoveMemberName} onClose={() => setOpenRemoveMemberName(false)} />
            <EditProject open={openEditProject} onClose={() => setOpenEditProject(false)} />
        </div>
    )
}

export default ProjectsDetailsTable

